import MarkdownIt from "markdown-it";

// ---------------------------------------------------------------------------
// Markdown das respostas da Lux.
//
// O texto vem de um LLM, ou seja, é conteúdo não confiável. `html: false` faz o
// markdown-it escapar qualquer tag crua, o que fecha o vetor de XSS sem
// precisar de sanitizador extra — mesma abordagem já usada no feed do QuimeraX
// (src/views/apps/quimerax-news/trf.ts). NÃO habilite `html` aqui.
// ---------------------------------------------------------------------------

const md = new MarkdownIt("commonmark", {
  html: false,
  linkify: true,
  breaks: true, // resposta de chat quebra linha sozinha; sem isso vira parágrafo único
})
  .enable("table")
  .enable("strikethrough");

const defaultLinkOpen =
  md.renderer.rules.link_open ||
  ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options));

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  const href = tokens[idx].attrGet("href") || "";

  // Link externo abre em aba nova e sem passar o referrer. Link interno do SPA
  // continua navegando na própria aba.
  if (href.startsWith("http://") || href.startsWith("https://")) {
    tokens[idx].attrSet("target", "_blank");
    tokens[idx].attrSet("rel", "noopener noreferrer");
  }

  return defaultLinkOpen(tokens, idx, options, env, self);
};

export const renderLuxMarkdown = (text?: string | null): string =>
  text ? md.render(text) : "";
